import awsmobile from "../aws-exports";
import { API, Storage, Auth } from "aws-amplify";
import { format } from "date-fns";

const API_NAME = awsmobile.aws_cloud_logic_custom[0].name;
Storage.configure({
  customPrefix: {
    public: "product/",
  },
});

const headersForApi = async () => ({
  headers: {
    Authorization: `Bearer ${(await Auth.currentSession())
      .getIdToken()
      .getJwtToken()}`,
  },
});
const dataProvider = {
  getList: (resource, params) => {
    return new Promise(async (resolve, reject) => {
      const getHeaders = await headersForApi();
      const { page, perPage } =
        params.pagination !== undefined && params.pagination;
      const businessId =
        params.businessId !== undefined && params.businessId !== ""
          ? `business_id=${params.businessId}&`
          : "";
      const branchId =
        params.branchId !== undefined && params.branchId !== ""
          ? `branch_id=${params.branchId}&`
          : "";
      const filters =
        params.filter !== undefined && params.filter !== ""
          ? params.filter
          : "";
      const query = {
        pag: params.pagination !== undefined ? page : "",
        numPag: params.pagination !== undefined ? perPage : "",
      };
      API.get(
        API_NAME,
        `/${resource}?${businessId}${branchId}${filters}&pag=${query.pag}&numPag=${query.numPag}&order=desc`,
        getHeaders
      )
        .then((res) => {
          if (
            resource.includes("transactionDetail/product") ||
            resource.includes("transactionDetail/product/v2")
          ) {
            let records = JSON.parse(res.result).records.map((item) => {
              item.id = item.id_td;
              delete item.id_td;
              return item;
            });
            resolve({
              data: records,
              totalClosingData: {
                total: JSON.parse(res.result)?.total ?? {},
                totalSale: JSON.parse(res.result)?.totalSale ?? {},
                totalVoid: JSON.parse(res.result)?.totalVoid ?? {}
              },
              total: JSON.parse(res.result).items,
              pag: JSON.parse(res.result).pag,
              totalAmount: JSON.parse(res.result).total ?? 0,
            });
          } else {
            if(typeof res.result === "string" && JSON.parse(res.result).records){
              resolve({
                data: res.result.records ?? JSON.parse(res.result).records,
                totalClosingData: {
                  total: res.result.records
                    ? res.result.records?.total
                    : JSON.parse(res.result)?.total ?? 0,
                  sec_total_amount: res.result.records
                    ? res.result.records?.sec_total_amount
                    : JSON.parse(res.result)?.sec_total_amount ?? 0,
                  totalSale: res.result.records
                    ? res.result.records?.totalSale
                    : JSON.parse(res.result)?.totalSale ?? 0,
                  totalVoid: res.result.records
                    ? res.result.records?.totalVoid
                    : JSON.parse(res.result)?.totalVoid ?? 0,
                },
                total: res.result.items ?? JSON.parse(res.result).items,
                pag:
                  typeof res.result === "string"
                    ? JSON.parse(res.result).pag
                    : res.result.pag ?? 1,
                totalAmount:
                  res.result.total ?? JSON.parse(res.result).total ?? 0,
              });
            } else{
              resolve({
                data: res.result ?? res.result,
                totalClosingData: {
                  total: res.result.records
                    ? res.result.records?.total
                    : res.result?.total ?? 0,
                  totalSale: res.result.records
                    ? res.result.records?.totalSale
                    : res.result?.totalSale ?? 0,
                  totalVoid: res.result.records
                    ? res.result.records?.totalVoid
                    : res.result?.totalVoid ?? 0,
                },
                total: res.result.items ? res.result.items : res.result.length ? res.result.length : 1,
                pag:
                  typeof res.result === "string"
                    ? res.result.pag
                    : res.result.pag ?? 1,
                totalAmount:
                  res.result.total ?? res.result.total ?? 0,
              });
            }
            
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getOne: (resource, params) => {
    return new Promise(async (resolve, reject) => {
      const getHeaders = await headersForApi();
      API.get(
        API_NAME,
        `/${resource}${resource.includes("?") ? params.id : "/" + params.id}`,
        getHeaders
      )
        .then((res) => {
          if(typeof res.result === "string"){
            resolve({
              data: JSON.parse(res.result).records[0],
            });
          }else{
            resolve({
              data: res.result.records[0],
            })
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getOneList: (resource, params) => {
    return new Promise(async (resolve, reject) => {
      const getHeaders = await headersForApi();
      if(params.id){
        API.get(API_NAME, `/${resource}/${params.id}`, getHeaders)
        .then((res) => {
          if(typeof res.result === "string"){
            resolve({
              data: JSON.parse(res.result).records,
            });
          }else{
            resolve({
              data: res.result,
            })
          }
         
        })
        .catch((err) => {
          reject(err);
        });
      }
      
    });
  },

  create: (resource, params) => {
    return new Promise(async (resolve, reject) => {
      const getHeaders = await headersForApi();
      API.post(API_NAME, `/${resource}?${params.urlParams}`, {
        ...getHeaders,
        body: params.objectData ?? {},
      })
        .then((res) => {
          resolve({
            data: {
              id: res.id ? res.id : 1,
              data: JSON.parse(res.result),
            },
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  update: (resource, params) => {
    return new Promise(async (resolve, reject) => {
      const getHeaders = await headersForApi();
      API.put(API_NAME, `/${resource}/${params.id}?${params.data.urlParams}`, {
        ...getHeaders,
        body: params.data.objectData ?? {},
      })
        .then((res) => {
          resolve({
            data: {
              id: res,
            },
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  delete: (resource, params) => {
    return new Promise(async (resolve, reject) => {
      const getHeaders = await headersForApi();
      API.del(
        API_NAME,
        `/${resource}${
          (typeof params.id === "string" || typeof params.id === "number") && !Array.isArray(params.id)
            ? `/${params.id}`
            : `?id=${resource === 'category' ? params.id :params.id.join(",")}`
        }${resource === 'category' ? "&"+params.data.urlParams : ""}`,
        getHeaders
      )
        .then((res) => {
          resolve({
            data: {
              id: params.id,
              status: 204,
            },
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // Data dashboard
  getDataDashboard: (resource, params) => {
    return new Promise(async (resolve, reject) => {
      const getHeaders = await headersForApi();
      let businessId = params.businessId === "0" ? "" : params.businessId;
      let branchId = params.branchId === "0" ? "" : params.branchId;

      API.get(
        API_NAME,
        `/${resource}?business_id=${businessId}&branch_id=${branchId}&date_local=${
          params.date ?? ""
        }`,
        getHeaders
      )
        .then((res) => {
          resolve({
            data: JSON.parse(res.result),
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // S3
  uploadImage: async (file, fileName) => {
    return new Promise(async (resolve, reject) => {
      try {
        const result = await Storage.put(
          `${format(new Date(), "dd-mm-yyyy-hh-mm-ss")}${fileName}`,
          file,
          {
            ACL: "public-read",
            ContentType: "image/jpeg",
          }
        );
        const response = {
          data: {
            Location:
              "https://" +
              process.env.REACT_APP_USER_UPLOAD_FILES_S3_BUCKET +
              "/product/" +
              result.key,
          },
        };
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },

  uploadZip: async (file, fileName) => {
    Storage.configure({
      customPrefix: {
        public: "public/",
      },
    });
    return new Promise(async (resolve, reject) => {
      try {
        const result = await Storage.put(
          `${format(new Date(), "dd-mm-yyyy-hh-mm-ss")}${fileName}`,
          file,
          {
            ACL: "public-read",
            ContentType: "application/zip",
          }
        );
        const response = {
          data: {
            Location:
              "https://" +
              awsmobile.aws_user_files_s3_bucket +
              ".s3.amazonaws.com/public/",
              result: result
          },
        };
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },

  uploadFileTerminals: (params, fileData) => {
    return new Promise(async (resolve, reject) => {
      let getHeaders = await headersForApi();
      API.post(API_NAME, `/terminal/bulkLoad?business=${params.business}&branch=${params.branch}`, {
        headers: getHeaders.headers,
        body: fileData,
      })
        .then((res) => {
          resolve({
            data: {
              id: 1,
              data: "",
              items_added: res.items_added,
              success: res.success,
            },
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  uploadFileProducts: (fileData) => {
    return new Promise(async (resolve, reject) => {
      let getHeaders = await headersForApi();
      API.post(API_NAME, `/product/bulkLoad`, {
        headers: getHeaders.headers,
        body: fileData,
      })
        .then((res) => {
          resolve({
            data: {
              id: 1,
              data: "",
              items_added: res.items_added,
              success: res.success,
            },
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  uploadFileProductsStock: (fileData,businessParams) => {
    return new Promise(async (resolve, reject) => {
      let getHeaders = await headersForApi();
      API.put(API_NAME, `/product/bulkLoad?business=${businessParams}`, {
        headers: getHeaders.headers,
        body: fileData,
      })
        .then((res) => {
          resolve({
            data: {
              id: 1,
              result: res.result,
              total: res.total,
              productsNames:res.productsNames,
              success: res.success,
            },
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  uploadImages: (fileData) => {
    return new Promise(async (resolve, reject) => {
      let getHeaders = await headersForApi();
      API.post(API_NAME, `/product/zip`, {
        headers: getHeaders.headers,
        body: fileData,
      })
        .then((res) => {
          resolve({
            data: {
              id: 1,
              result: res.result,
              total: res.total,
              success: res.success,
            },
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  uploadFileBusiness: (params, fileData) => {
    return new Promise(async (resolve, reject) => {
      let getHeaders = await headersForApi();
      API.post(API_NAME, `/business/update?business=${params.business}&branch=${params.branch}`, {
        headers: getHeaders.headers,
        body: fileData,
      })
        .then((res) => {
          resolve({
            data: {
              id: 1,
              data: "",
              items_added: res.items_added,
              success: res.success,
              business_id: res.business_id,
            },
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  updateChangePassword: (fileData) => {
    return new Promise((resolve, reject) => {
      API.post(API_NAME, `/password/update`, {
        body: fileData,
      })
        .then((res) => {
          resolve({
            data: {
              id: 1,
              result: res.result,
              success: res.success,
            },
          });
        })
        .catch((err) => {
          const responseError = err.response.data
          reject({...responseError});
        });
    });
  },

  validatePassword: (fileData) => {
    return new Promise((resolve, reject) => {
      API.post(API_NAME, `/password/validate-password`, {
        body: fileData,
      })
        .then((res) => {
          resolve({
            data: {
              id: 1,
              result: res.result,
              success: res.success,
            },
          });
        })
        .catch((err) => {
          const responseError = err.response.data
          reject({...responseError});
        });
    });
  },

  registerPassword: (fileData) => {
    return new Promise(async (resolve, reject) => {
      let getHeaders = await headersForApi();
      API.post(API_NAME, `/password`, {
        headers: getHeaders.headers,
        body: fileData,
      })
        .then((res) => {
          resolve({
            data: {
              id: 1,
              result: res.result,
              success: res.success,
            },
          });
        })
        .catch((err) => {
          const responseError = err.response.data
          reject({...responseError});
        });
    });
  },

  deleteImage: (fileName) => {
    return new Promise((resolve, reject) => {
      Storage.remove("test.txt")
        .then(() => {
          resolve({
            data: "Successfully removed",
          });
        })
        .catch((err) => {
          console.error("Unexpected error while removing", err);
          reject(err);
        });
    });
  },
};

export default dataProvider;
